<template>
  <b-container>
    <b-row style="margin-top: 20px">
      <b-col cols="1">
        <b-button style="width: 50px" variant="third" @click="clearNode()">
          <i class="bi bi-chevron-double-left"></i>
        </b-button>
      </b-col>
      <b-col style="align-items: center" cols="10">
        <div class="d-flex justify-content-center">
          <b-row align-h="around">
            <b-col cols="6">
              <b-button
                style="width: 140px"
                variant="primary"
                :disabled="!isPreviousEnabled"
                @click="moveNode(false)"
              >
                <span class="bi-chevron-left" />
                {{ $t("label_evaluation_requirementEvaluation_previous") }}
              </b-button>
            </b-col>
            <b-col cols="6">
              <b-button
                style="width: 140px"
                variant="primary"
                :disabled="!isNextEnabled"
                @click="moveNode(true)"
              >
                {{ $t("label_evaluation_requirementEvaluation_next") }}
                <span class="bi-chevron-right" />
              </b-button>
            </b-col>
          </b-row>
        </div>
      </b-col>
    </b-row>
  </b-container>
</template>

<script>
export default {
  name: "TemplateEvaluationNavigationButtons",
  props: ["isPreviousEnabled", "isNextEnabled"],

  methods: {
    moveNode(advance) {
      this.$emit("moveEvaluatingNode", advance);
    },
    clearNode() {
      this.$emit("clearEvaluatingNode");
    },
  },
};
</script>

<style lang="sass" >
/* components/template/_template-evaluation-navigation-buttons.vue */
</style>